import { jsx as _jsx } from "react/jsx-runtime";
import { Facebook } from "./Facebook";
import { Instagram } from "./Instagram";
import { LinkedIn } from "./LinkedIn";
import { Pinterest } from "./Pinterest";
import { Spotify } from "./Spotify";
import { Twitter } from "./Twitter";
import { Vimeo } from "./Vimeo";
import { WhatsApp } from "./WhatsApp";
import { Youtube } from "./Youtube";
export const socialNetworks = {
    facebook: _jsx(Facebook, {}, void 0),
    instagram: _jsx(Instagram, {}, void 0),
    linkedin: _jsx(LinkedIn, {}, void 0),
    pinterest: _jsx(Pinterest, {}, void 0),
    spotify: _jsx(Spotify, {}, void 0),
    twitter: _jsx(Twitter, {}, void 0),
    vimeo: _jsx(Vimeo, {}, void 0),
    whatsapp: _jsx(WhatsApp, {}, void 0),
    youtube: _jsx(Youtube, {}, void 0),
};
//# sourceMappingURL=index.js.map